import { editTopic } from 'common/constants/permissions';

const canEditTopic = permissions => !!permissions[editTopic];

export default {
    canEditTopic
};
